module.exports = __webpack_public_path__ + "images/dropbox-mark.9b13c8944db93b6233bb.svg";